var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVectorFullWidthSmall = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100%",
  height: "100%",
  viewBox: "0 0 375 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M69.25 21.5H12C5.37258 21.5 0 16.1274 0 9.5V0H375.5V6.75C375.5 14.8962 368.896 21.5 360.75 21.5H355.25C350.141 21.5 346 25.6414 346 30.75C346 35.8586 341.859 40 336.75 40H281.5C274.873 40 269.5 34.6274 269.5 28V18C269.5 11.3726 264.127 6 257.5 6H84.75C80.4698 6 77 9.46979 77 13.75C77 18.0302 73.5302 21.5 69.25 21.5Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVectorFullWidthSmall);
export default ForwardRef;